import React from "react";
import "./FnB1.scss";
import data from "./data.json";
import Card from "../../../Component/Card/card";
import Madisonimages from "../../../Media/Ruko Paramount/Madison Grande/Madison";
import HamptonAvenueimages from "../../../Media/Ruko Paramount/Hampton Avenue/Hampton Avenue";
import westvillageimages from "../../../Media/Ruko BSD/West Village/westvillage";
import HamptonEastimages from "../../../Media/Ruko Paramount/Hampton East/HamptonEast";
import MentengStudioimages from "../../../Media/Ruko Paramount/Menteng Studio Loft/MentengStudio";
import MagioreBusinessimages from "../../../Media/Ruko Paramount/Magiore Business/MagioreBusiness";
import Xlaneimages from "../../../Media/Ruko BSD/Xline/Xlane";
import Asterraimages from "../../../Media/Ruko BSD/Asterra/Asterra";
import Latinosimages from "../../../Media//Ruko BSD/Latinos/latinos";
import Theloopimages from "../../../Media/Ruko BSD/The Loop/Theloop";
import iLagoGrandeimages from "../../../Media/Ruko Paramount/iLago Grande/iLagoGrande";
import Vanyaparkimages from "../../../Media/Ruko BSD/Vanya/Vanya";
import Northridgeimages from "../../../Media/Ruko BSD/Northridge/Northridge";
import Cascadeimages from "../../../Media/Ruko BSD/Cascade/Cascade";
import Tamanteknoimages from "../../../Media/Ruko BSD/Taman Tekno/Tamantekno";
import Delreyimages from "../../../Media/Ruko BSD/Delrey/delrey";
import Iconiximages from "../../../Media/Ruko BSD/Iconix/Iconix";
import Northpointimages from "../../../Media/Ruko BSD/NTP/Northpoint";
import Capitalcoveimages from "../../../Media/Ruko BSD/Capital Cove/Capitalcove";
import NavaparkBusinessimages from "../../../Media/Ruko BSD/Navapark Business Suites/NavaparkBusiness";
import MagioreSignatureimages from "../../../Media/Ruko Paramount/Magiore Signature/MagioreSignature";
import Quantumimages from "../../../Media/Ruko Paramount/Quantum/Quantum";
import Pasadenaimages from "../../../Media/Ruko Paramount/Pasadena/Pasadena";
import Hudsonimages from "../../../Media/Ruko Paramount/The Hudson/Hudson";
import IconixIimages from "../../../Media/Ruko BSD/Iconix Infinite/IconixI";

const imageMap = {
  Latinosimages,
  Madisonimages,
  Theloopimages,
  MagioreSignatureimages,
  iLagoGrandeimages,
  HamptonAvenueimages,
  westvillageimages,
  Vanyaparkimages,
  Xlaneimages,
  Northridgeimages,
  HamptonEastimages,
  Cascadeimages,
  Tamanteknoimages,
  Delreyimages,
  Iconiximages,
  MentengStudioimages,
  Capitalcoveimages,
  Northpointimages,
  MagioreBusinessimages,
  NavaparkBusinessimages,
  Asterraimages,
  Quantumimages,
  Pasadenaimages,
  Hudsonimages,
  IconixIimages,

  // Add other image arrays here if you have more sets
};

const produk = () => {
  return (
    <div id="Bestbuying" className="produk">
      <h1>Best Buying Commercial </h1>
      <h2>Pilihan Terbaik Untuk Memenuhi Bisnis Anda</h2>
      <div className="cardhome-container">
        {data.cards.map((card, index) => {
          // Determine the logo dynamically
          // Determine the logo dynamically
          return (
            <Card
              key={index}
              carousel={imageMap[card.imagesKey]}
              title={card.title}
              subtitle={card.subtitle}
              price={card.price}
              subprice={card.subprice}
              details={card.details}
              whatsappLink={card.whatsappLink} // Pass the WhatsApp link
            />
          );
        })}
      </div>
    </div>
  );
};

export default produk;
